import { Routes } from '@angular/router';
import { DashboardComponent } from './core/layout/pages/dashboard/dashboard.component';
import { ArchivedComponent } from './features/todo/archived/archived.component';
import { TodoComponent } from './features/todo/todo.component';

export const routes: Routes = [
  {
    path: 'home',
    component: TodoComponent,
  },
  {
    path: 'archived',
    component: ArchivedComponent,
  },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];
